export const IGetAppUpdateUseCaseType = Symbol('IGetAppUpdateUseCase');
